const stripColor = [
  {
    id: 1,
    type: "weatherStripColor",
    isNew: false,
    label: "Bronze",
  },
  {
    id: 2,
    type: "weatherStripColor",
    isNew: false,
    label: "White",
  },
  {
    id: 3,
    type: "weatherStripColor",
    isNew: false,
    label: "Black",
  },
];

const alumStripColor = [
  {
    id: 1,
    type: "weatherStripColor",
    label: "Black",
  },
  {
    id: 2,
    type: "weatherStripColor",
    label: "Grey",
  },
];

export { stripColor, alumStripColor };
